import { acceptHMRUpdate, defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useTemplateStore = defineStore('template', () => {
    const all = ref({ data: [] });

    const active = ref({});

    const reset = () => {
        all.value = { data: [] };
    };

    const search = (params) => {
        return axios.get('/api/v1/templates', { params });
    };

    const store = () => {
        return axios.post('/api/v1/templates');
    };

    const update = (params) => {
        return axios.patch(`/api/v1/templates/${params.hash}`, params);
    };

    return {
        active,
        all,
        reset,
        search,
        store,
        update
    };
});

// HMR
if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useTemplateStore, import.meta.hot));
}
